import React from "react";
import { useSettingsVM } from "./SettingsViewModel";
import SettingsView from "./SettingsView";
import { useUnitsSettingsVM } from "../UnitsSettings/UnitsSettingsViewModel";

interface Props {
  tag: string;
  token: string;
  testAlarms: number;
  loggedID: string;
  loggedState: number;
  onCloseModal?: () => void;
}

const Settings: React.FC<Props> = (props) => {
  const settingsVM = useSettingsVM(
    props.tag,
    props.token,
    props.testAlarms,
    props.loggedID,
    props.onCloseModal
  );
  
  const unitsVM = useUnitsSettingsVM(props.loggedID);

  return (
    <SettingsView
      tag={props.tag}
      state={settingsVM.state}
      actions={settingsVM.actions}
      unitsState={unitsVM.state}
      unitsActions={unitsVM.actions}
      loggedState={props.loggedState}
      isModal={Boolean(props.onCloseModal)}
    />
  );
};

export default Settings;